import { render } from "./Wysiwyg_tiptap.vue?vue&type=template&id=2b4c9b67"
import script from "./Wysiwyg_tiptap.vue?vue&type=script&lang=js"
export * from "./Wysiwyg_tiptap.vue?vue&type=script&lang=js"

import "./Wysiwyg_tiptap.vue?vue&type=style&index=0&id=2b4c9b67&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__